/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
function cartCount(){ 
  $.getJSON('/cart.js', function(cart) { 
    if (cart.item_count >= 9){
      $("[data-cart-toggle] .header__cart__status").text('9+'); 
    }else{
    $("[data-cart-toggle] .header__cart__status").text(cart.item_count);   
    }
    
    if(cart.item_count == 0){ $('[data-cart-toggle] .header__cart__status').hide(); } else{ $('[data-cart-toggle] .header__cart__status').css('display', 'inline-flex'); }
  });
}
function openDrawer(currentThis){
  // $.ajax({
  //   type: "GET", 
  //   url: "/",
  //   dataType: 'html',
  //   success: function(data){
  //     // var miniCartHead = $('.cdk_hidden_html').html(data).find("#cart-drawer").html();
  //     // $('#cart-drawer').html(miniCartHead);
  //     $('#cart-drawer').html($(data).find('#cart-drawer').html());
  //     // console.log(miniCartHead);
  //   }
  // })
 $.ajax({
    url: '/',
   dataType: 'html',
    success: function(response) {
       $('#cart-drawer').removeClass('is-empty');
        var updatedCartDrawer = $(response).find('#rb-drawer').html();
        $('#rb-drawer').html(updatedCartDrawer);
      $('.cart-block').addClass('is-animated');
      $('.cart__item').addClass('is-animated');
        console.log(updatedCartDrawer);
    }
});

}

  function updateCartWithItems(cartData) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'json',
      success: function (cart) {
        //console.log('Cart updated successfully:', cart);
        cartCount()
        openDrawer() 
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error('Error updating cart:', errorThrown);
        // Handle the error, if any.
      },
    });
  }

function ajaxAddToCartProduct(currentThis,dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      cartCount();
      
      setTimeout(function () {
        openDrawer();
        $('#cart-drawer').addClass('is-open custom_cart_btns');
      },1000);
      
      // setTimeout(function () {
      //   $('#cart-drawer .drawer__inner').find('*').addClass('is-animated');
      //   $('body').css({'overflow':'hidden', 'padding-right': '17px'});
      // },2500);
            
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

$(document).ready(function(){
  // bundle option selected js
  $(document).mouseup(function (e) {
    if ($(e.target).closest(".swatches-block-box").length === 0) {
        $(".swatches-block .option_label").removeClass('active');
        $(".swatches-block-box").removeClass('open');
    }
  });
  var lopchk = 0;
  $(document).on('click','.bundle-product-option .swatches-block .option_label:not(.active)', function () {
    if(lopchk == 0){
    $(this).addClass('active');
    $(this).next('.swatches-block-box').addClass('open');
      lopchk = lopchk + 1;
    }else{
     lopchk = 0;
    }
  })
  $(document).on('click','.bundle-product-option .swatches-block .option_label.active', function () {
    if(lopchk == 0){
    $(this).removeClass('active');
    $(this).next('.swatches-block-box').removeClass('open');
    lopchk = lopchk + 1;
    }else{
     lopchk = 0;
    }
  })
  $(document).on('click','.bundle-product-option .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    $(this).parents('.swatches-block-box').removeClass('open');
    $(this).parents('.swatches-block').find(".option_label").removeClass('active');
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName);
    // console.log("OptionName::"+OptionName);
  })

  $(document).on('change','.swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    console.log('thisParentId::'+thisParentId);
    $('.product-swatches[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      // console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    // console.log('newstr::'+newstr);     
    var optionName_Selector = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]');
    var optionName_val = optionName_Selector.val(); 
    $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change(); 
  });
  $(document).on('change','.product-swatches select.product_card-form__master-select', function () {
    var thisMainVal = $(this).val(); 
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    // console.log('thisMainVal::'+thisMainVal);
    var ThisSellingPlan = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val();
    // console.log('ThisSellingPlan::'+ThisSellingPlan);
    var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
    // console.log('ThisProdAvail::'+ThisProdAvail);
  // $('.cdk-add-bundle').attr('data-variant', thisMainVal).attr('data-sellingplan',ThisSellingPlan);
      
    var thisMainVal1 = $('.bundle-product-one select.product_card-form__master-select').val(); 
    var ThisProdAvail1 =$('.bundle-product-one select.product_card-form__master-select').find('option[value="'+thisMainVal1+'"]').attr('data-varaint-availability');
    var thisMainVal2 = $('.bundle-product-second select.product_card-form__master-select').val(); 
    var ThisProdAvail2 =$('.bundle-product-second select.product_card-form__master-select').find('option[value="'+thisMainVal2+'"]').attr('data-varaint-availability');
    
    // console.log('thisMainVal1::'+ thisMainVal1);
    // console.log('ThisProdAvail1::'+ ThisProdAvail1);
    // console.log('thisMainVal2::'+ thisMainVal2);
    //  console.log('ThisProdAvail2::'+ ThisProdAvail2);
    
    if (ThisProdAvail1 == 'true' && ThisProdAvail2 == 'true'){
      $('.form__wrapper').removeClass('variant--soldout');
       $('.cdk-add-bundle').removeClass('disable');
      $('.cdk-add-bundle').find('.btn_text').text('add to bag');
    }else{ 
      $('.form__wrapper').addClass('variant--soldout');
      $('.cdk-add-bundle').addClass('disable');
      $('.cdk-add-bundle').find('.btn_text').text('sold out');
    }   
  });

  $(document).on('click','.cdk-add-bundle', function(event){ 
    event.preventDefault();
    var quantity = $('.QuantitySelector__CurrentQuantity').val();
    var currentThis = $(this);
    var updateItems = [];
    $(this).parents('.product__content ').find('.bundle-product-option').each(function(){
      var thisParentId = $(this).children('.product-swatches').attr('data-id');
      var thisId = $(this).children('.product-swatches[data-id="'+thisParentId+'"]').find('select.product_card-form__master-select').val();
      // console.log('thisId::'+ thisId); 
      updateItems.push({ "id": thisId, "quantity": quantity });
    })
    ajaxAddToCartProduct(currentThis,updateItems);
    
  });
 var thisMainVal1 = $('.bundle-product-one select.product_card-form__master-select').val(); 
  var ThisProdAvail1 =$('.bundle-product-one select.product_card-form__master-select').find('option[value="'+thisMainVal1+'"]').attr('data-varaint-availability');
  var thisMainVal2 = $('.bundle-product-second select.product_card-form__master-select').val(); 
  var ThisProdAvail2 =$('.bundle-product-second select.product_card-form__master-select').find('option[value="'+thisMainVal2+'"]').attr('data-varaint-availability');

    // console.log('thisMainVal1::'+ thisMainVal1);
    // console.log('ThisProdAvail1::'+ ThisProdAvail1);
    // console.log('thisMainVal2::'+ thisMainVal2);
    // console.log('ThisProdAvail2::'+ ThisProdAvail2);
  if (ThisProdAvail1 == 'true' && ThisProdAvail2 == 'true'){
    $('.form__wrapper').removeClass('variant--soldout');
     $('.cdk-add-bundle').removeClass('disable');
     $('.cdk-add-bundle').find('.btn_text').text('add to bag');
    var pd_price = $('.cdk-add-bundle').attr('data-price');
     $('.cdk-add-bundle').find('.btn_text').append('<span class="bt-pric">' + pd_price + '</span>');
    $('.cdk-add-bundle').attr('data-btn', 'Add To Cart' );
  }else{ 
    $('.cdk-add-bundle').addClass('disable');
    $('.form__wrapper').addClass('variant--soldout');
    $('.cdk-add-bundle').find('.btn_text').text('sold out');
    $('.cdk-add-bundle').attr('data-btn', 'soldout' );
  }


  $(document).on('click', '.custom_cart_btns .cart__quantity-plus', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};
    $(this).parents('.drawer__body').addClass('loading');
     var qtySelector = $(this).parents('.cart__quantity').find('input.cart__quantity-field');
    var thisVarId = $(this).parents('.cart__quantity').find('input.cart__quantity-field').attr('data-id');
      var qtyval  = parseInt(qtySelector.val());    
    console.log('qtyval::'+qtyval);
      // var qtyval = qtyval + 1;  
    console.log('thisVarId::'+thisVarId)
     $(qtySelector).val(qtyval);
      // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })

    $(document).on('click', '.custom_cart_btns .cart__quantity-minus', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};
    $(this).parents('.drawer__body').addClass('loading');
     var qtySelector = $(this).parents('.cart__quantity').find('input.cart__quantity-field');
      var thisVarId = $(this).parents('.cart__quantity').find('input.cart__quantity-field').attr('data-id');
      var qtyval = parseInt(qtySelector.val());    
      // var qtyval = qtyval - 1; 
      console.log('qtyval::'+qtyval);
     $(qtySelector).val(qtyval);
      console.log('thisVarId::'+thisVarId)
      console.log('qtyval::'+qtyval)
       // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })

    $(document).on('click', '.custom_cart_btns .cart__item__remove', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};     
      $(this).parents('.drawer__body').addClass('loading');
      var thisVarId = $(this).attr('data-id');
      var qtyval = 0;    
       // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })
 $(document).on('click', '.custom_cart_btns span.drawer__underlay, .custom_cart_btns button.drawer__close', function () {
     $('#cart-drawer').removeClass('is-open');
  })

  
});





